// extracted by mini-css-extract-plugin
export default {"SelectorWrapper":"Select_SelectorWrapper__UpbUu","title":"Select_title__+uTg8","Select":"Select_Select__RaMP2","input":"Select_input__n3gZZ","inp_label":"Select_inp_label__vAQrp"};